import _ from "lodash";
import { getGridStickyDefaults, setGridStickyDefaults } from "../../app/core/util/stickyDefaults";
import { controls, settings } from "../../framework";
import * as maskUtil from "../components/mask";
import { clone } from "../core/core";
import * as divisionRegion from "../core/division.region";
import * as zKendo from "../core/kendo";
import { ll, LocalizedLanguage } from "../core/ll";
import { user } from "../core/user";
import { emptyFn, isFunction } from "../core/util";
import { buildODataKendoParams } from "../data/buildODataKendoParams";
import { dataSource } from "../data/dataSource";
import { getSchemaProperty, schemas } from "../data/schemas";
import { searchTypes } from "../data/searchTypes";
import * as layout from "./buildGridColumns";
import { SignaturePopup } from "./components/signaturePopup";
import { fixGridFilterMenuForChrome, GridFilterMenu } from "./gridFilterMenu";
import * as gridUtil from "./gridUtil";
import * as searchOptions from "./searchOptions";

export function grid(options) {
    options = options || {};

    if (window.z.debuggerAttached && !options.widget) {
        console.warn("This way of creating grids is deprecated.\n"
            + "Use ServicePro\\Scripts\\framework\\dataComponents\\components\\grid instead.");
    }

    var id = getGridIdFromOptions(options);

    // If the grid has already been created return the grid kendo object
    if ($(`#${id}`).data("kendoGrid")) {
        return $(`#${id}`).data("kendoGrid");
    }

    initializeOptions(options);

    // DO NOT REMOVE THIS EACH BLOCK. THIS CHUNK HAS TO BE RUN BEFORE APPLYING TEMPLATES TO COLUMNS.
    // THIS IS WHAT HACKS IN A TYPE OF CODE IN OUR SCHEMA
    $.each(options.entityTypes, function (index, type) {
        var splitType = type.split("/"),
            parentSchemaName = type;
        if (parentSchemaName.indexOf("/") != -1) {
            parentSchemaName = parentSchemaName.substring(parentSchemaName.indexOf("/") + 1);
        }
        if (splitType.length >= 2) {
            var typeName = splitType[splitType.length - 1],
                parentSchema = schemas[options.mainEntityType];
            $.each(splitType, function (i: any, t) {
                if (i == 0) {
                    parentSchema = schemas[t];
                } else if (i + 1 != splitType.length) {
                    parentSchema = schemas[parentSchema.NavigationProperties[t].Type];
                }
            });
            var typesSchemaName = parentSchema.NavigationProperties[typeName].Type;

            // RUNNING THIS FUNCTION ON EACH ENTITY TYPE IS CRITICAL. WITHIN THIS BLOCK WE
            // SET A PROPERTY TYPE OF CODE WHICH DOSENT ACTUALLY EXIST IN OUR SCHEMA
            layout.buildGridColumns({
                schemaName: typesSchemaName,
                schema: schemas[typesSchemaName],
                parentSchemaName: parentSchemaName.replaceAll("/", ".") + ".",
                codeColumnsToIgnore: options.codeColumnsToIgnore
            });
        }
    });

    applyTemplatesToColumns(options);

    loadStickyDefaultsPageSizeAndSort(options);
    initializeDataSource(options);

    delete options.sort;
    delete options.filter;

    if (options.schema) {
        options.columns = layout.buildGridColumns({
            schemaName: options.schema,
            schema: schemas[options.schema],
            show: options.show,
            hide: options.hide,
            codeColumnsToIgnore: options.codeColumnsToIgnore
        });
    }

    var columnOrder = options.columnOrder || [],
        columns = options.columns || [],
        pushColumns = options.pushColumns === undefined
            ? (columnOrder.length == 0)
            : options.pushColumns;

    options.divisions = options.divisions === undefined
        ? options.searchType.divisions
        : options.divisions;

    options.regions = options.regions === undefined
        ? options.searchType.regions
        : options.regions;

    if ((options.divisions || options.regions) && user && user.companyData && user.companyData.DivisionAndRegionEnabled) {

        options.divisionsNavigationTypes = options.divisionsNavigationTypes === undefined
            ? options.searchType.divisionsNavigationTypes
            : options.divisionsNavigationTypes;

        options.regionsNavigationTypes = options.regionsNavigationTypes === undefined
            ? options.searchType.regionsNavigationTypes
            : options.regionsNavigationTypes;

        options.divisionsFilterOverride = options.divisionsFilterOverride === undefined
            ? options.searchType.divisionsFilterOverride
            : options.divisionsFilterOverride;

        options.regionsFilterOverride = options.regionsFilterOverride === undefined
            ? options.searchType.regionsFilterOverride
            : options.regionsFilterOverride;

        options.regionNotRequired = options.regionNotRequired === undefined
            ? options.searchType.regionNotRequired
            : options.regionNotRequired;

        options.title = options.title === undefined
            ? options.searchType.title
            : options.title;

        options.divisionsAndRegionsAndMyStuff = options.divisionsAndRegionsAndMyStuff === undefined
            ? options.searchType.divisionsAndRegionsAndMyStuff
            : options.divisionsAndRegionsAndMyStuff;

        options.defaultDivisionSearchOption = options.defaultDivisionSearchOption === undefined
            ? options.searchType.defaultDivisionSearchOption
            : options.defaultDivisionSearchOption;

        options.defaultRegionSearchOption = options.defaultRegionSearchOption === undefined
            ? options.searchType.defaultRegionSearchOption
            : options.defaultRegionSearchOption;

        var divAndRegOptions = divisionRegion.createDivisionAndRegionSearchOptions(options);

        if (options.divisions) {
            options.searchOptions.push(divAndRegOptions.division);
        }

        if (options.regions) {
            if (!options.isSearchPopUp) {
                divAndRegOptions.region.showSearchPopUp = true;
            }
            options.searchOptions.push(divAndRegOptions.region);
        }
    }

    var so = searchOptions.initialize({
        options: options,
        _id: id,
        pushColumns: pushColumns,
        columnOrder: columnOrder
    });

    options.searchOptions = so.searchOptions;
    columnOrder = so.columnOrder;

    if (options.searchOptions.length > 0) {
        searchOptions.render({ options: options, _id: id });
    } else {
        $(`#${id}_SearchContainer`).css("min-height", "0").css("padding-top", 0);
    }

    var allColumns: any[] = layout.buildGridColumns({
        schemaName: options.mainEntityType,
        schema: schemas[options.mainEntityType],
        codeColumnsToIgnore: options.codeColumnsToIgnore
    });

    allColumns = allColumns.getUniqueListOfObjects("field");

    $.each(options.entityTypes, function (index, type) {
        var splitType = type.split("/"),
            parentSchemaName = type;

        if (parentSchemaName.indexOf("/") != -1) {
            parentSchemaName = parentSchemaName.substring(parentSchemaName.indexOf("/") + 1);
        }

        if (splitType.length >= 2) {
            var typeName = splitType[splitType.length - 1],
                parentSchema = schemas[options.mainEntityType];

            $.each(splitType, function (i: any, t) {
                if (i == 0) {
                    parentSchema = schemas[t];
                } else if (i + 1 != splitType.length) {
                    parentSchema = schemas[parentSchema.NavigationProperties[t].Type];
                }
            });

            var typesSchemaName = parentSchema.NavigationProperties[typeName].Type,
                otherColumns = layout.buildGridColumns({
                    schemaName: typesSchemaName,
                    schema: schemas[typesSchemaName],
                    parentSchemaName: parentSchemaName.replaceAll("/", ".") + ".",
                    codeColumnsToIgnore: options.codeColumnsToIgnore
                });

            allColumns = allColumns.concat(otherColumns);
        }
    });

    var gridColumns = [];

    // Walk through columnOrder to put the grid columns in order
    $.each(columnOrder, function (columnsIndex, column) {
        var foundColumn = $.grep(allColumns, function (allColumn) {
            var field = allColumn.field.getAllAfterLastInstanceOf(".");
            return allColumn.field == column || field == column;
        });
        if (foundColumn.length > 0) {
            foundColumn[0].hidden = false;
            gridColumns.push(foundColumn[0]);
        } else {
            var gridColumnObj;
            if ($.type(column) == "string") {
                gridColumnObj = {
                    field: column,
                    hidden: false,
                };
            } else {
                gridColumnObj = column;
            }
            var property = getSchemaProperty({
                entity: options.mainEntityType,
                property: gridColumnObj.field
            });
            if (property) {
                if ($.inArray(gridColumnObj.field, options.codeColumnsToIgnore) != -1) {
                    property.Type = null;
                }
                gridColumnObj.template = gridColumnObj.template ||
                    layout.getTemplateForType({
                        type: property.Type,
                        field: gridColumnObj.field,
                        codeName: gridColumnObj.codeName,
                        codeProperty: gridColumnObj.codeProperty,
                        codeFieldIdName: gridColumnObj.codeFieldIdName,
                        UserDefinedListId: gridColumnObj.UserDefinedListId
                    });
            }
            gridColumns.push(gridColumnObj);
        }
    });
    // After walking through make sure to add rest of columns that have not made it in.
    $.each(allColumns, function (allColumnsIndex, allColumn) {
        var notFound = true;
        $.each(gridColumns, function (index, gridColumn) {
            if (gridColumn.field == allColumn.field) {
                notFound = false;
            }
        });

        if (notFound) {
            allColumn.hidden = true;
            gridColumns.push(allColumn);
        }
    });

    $.each(columns, function (ecIndex, column) {
        var foundColumns = [];

        $.each(gridColumns, function (index, gridColumn) {
            if (gridColumn.field == column.field) {
                foundColumns.push({ index: index, gridColumn: gridColumn });
            }
        });

        if (foundColumns.length > 1) {
            // TODO: Remove dupe
        }

        if (foundColumns.length == 1) {
            var foundColumn = foundColumns[0];

            // TODO Do some work here to fix/add missing properties
            if (column.hidden === undefined) {
                column.hidden = false;
            }
            $.extend(gridColumns[foundColumn.index], column);
        } else if (foundColumns.length == 0) {
            gridColumns.push(column);
        }
    });

    var removeMe = [];
    $.each(gridColumns, function (llIndex, columnToLocalized) {
        if (columnToLocalized.field != null) {
            if (!columnToLocalized.title) {
                columnToLocalized.title = columnToLocalized.field;
            }

            var localizedLabel = "";
            if (columnToLocalized.title.indexOf(" ") == -1) {
                localizedLabel = ll(columnToLocalized.title, true);
            }

            var screenEntityTypeLL = ll(options.searchType.screenEntityType + "." + columnToLocalized.field, true),
                fieldLL = ll(columnToLocalized.field, true);

            if (options.searchType.screenEntityType && screenEntityTypeLL != fieldLL) {
                localizedLabel = screenEntityTypeLL;
            }

            if (options.columnRenames[columnToLocalized.field]) {
                localizedLabel = ll(options.columnRenames[columnToLocalized.field], true);
            }

            columnToLocalized.title = localizedLabel || columnToLocalized.title;

            if (options.columnsToHide.indexOf(columnToLocalized.field) != -1) {
                removeMe.push(llIndex);
            }
        }
    });

    for (var ii = removeMe.length - 1; ii >= 0; ii--) {
        gridColumns.splice(removeMe[ii], 1);
    }

    options.columns = gridColumns;

    var kGrid = options.gridObject || $(id);
    if (kGrid.length == 0) {
        kGrid = $(`#${id}`);
    }

    // if print is enabled create an unmask callback for excel export
    if (options.allowExcelExport) {
        options.excelExport = function (e) {
            zKendo.restoreExpr();

            var sheet = e.workbook.sheets[0],
                columnNumber = 0;

            for (var i = 0; i < this.columns.length; i++) {
                var column = this.columns[i];
                if (column.hidden || !column.template) {
                    continue;
                }

                var template = kendo.template(column.template);
                for (var j = 1; j < sheet.rows.length; j++) {
                    var row = sheet.rows[j],
                        data = e.data[j - 1];
                    row.cells[columnNumber].value = $($.parseHTML(template(data))).text();
                }
                columnNumber++;
            }

            kGrid.unmask();
        };
    }

    var dataBound = options.dataBound || emptyFn,
        previousPageSize,
        previousSort;

    if (options.stickyDefaultName) {
        previousPageSize = options.dataSource === undefined
            ? options.dataSource.pageSize && options.dataSource.pageSize()
            : options.defaultPageSize;
        previousSort = options.dataSource && options.dataSource.sort
            ? options.dataSource.sort()
            : undefined;
    }

    options.dataBound = function (e) {
        var kendoGrid = kGrid.data("kendoGrid");

        if (options.stickyDefaultName) {
            var pageSize = kendoGrid.dataSource.pageSize(),
                sort = kendoGrid.dataSource.sort(),
                pageSizeChanged = pageSize != previousPageSize,
                sortChanged = !_.isEqual(sort, previousSort);

            if (pageSizeChanged || sortChanged) {
                saveStickyDefaults(options, kendoGrid);
            }

            previousPageSize = pageSize;
            previousSort = sort;
        }

        if (kendoGrid && kendoGrid.dataSource.page() != 1 && kendoGrid.dataSource.page() > kendoGrid.dataSource.totalPages()) {
            kendoGrid.dataSource.page(1);
        }

        $.each(kendoGrid.columns, function (index, column) {
            if (column.zHeaderElement && !column.zHeaderElement.addClass) {
                column.zHeaderElement = null;
                column.zFiltered = null;
            }
            if (!column.zHeaderElement) {
                column.zHeaderElement = kendoGrid.thead.find(`.k-link:contains(${column.title})`)
                    .parents("th.k-header")
                    .find(".k-header-column-menu");
            }

            if (column.zFiltered) {
                $.wait(100).then(function () {
                    column.zHeaderElement.addClass("k-state-active");
                });
            }
        });

        kendoGrid.tbody.find('a[href="#"]').removeAttr("href");

        dataBound.apply(this, [e]);
    };

    options.columnReorder = function (e) {
        $.wait(100).then(function () {
            saveStickyDefaults(options, kGrid.data("kendoGrid"));
        });
    };

    options.columnResize = function (e) {
        gridUtil.setGridMinimumWidth($(this.element), $(this.element).data("kendoGrid").getOptions().columns);
        saveStickyDefaults(options, kGrid.data("kendoGrid"));
    };

    var columnsChanged = function () {
        $(`#${id}`).data("kendoGrid").wrapper.find(".k-icon.k-i-reload").click();
    };

    options.columnHide = function (e) {
        gridUtil.setGridMinimumWidth($(this.element), $(this.element).data("kendoGrid").getOptions().columns);
        columnsChanged();
        saveStickyDefaults(options, kGrid.data("kendoGrid"));
    };

    options.columnShow = function (e) {
        gridUtil.setGridMinimumWidth($(this.element), $(this.element).data("kendoGrid").getOptions().columns);
        columnsChanged();
        saveStickyDefaults(options, kGrid.data("kendoGrid"));
    };

    options.sort = function (e) {
        gridUtil.firstPage(options.dataSource);
    };

    // From kendo source code for the columnShow event:
    // column = grep(columns, function (column) {
    //    return column.field == field || column.title == field;
    // })[0];
    // When you click the column menu to show another column it looks for either the field or the title to determine which column to show
    // We have fields like BillTo.ShipTo.City and City both with the title of City and depending on column order it can show or hide the wrong column
    // This means we can NEVER have a title with the same value as any field
    _.each(options.columns, function (column) {
        if (column.title && !_.endsWith(column.title, " ")) {
            column.title = `${column.title} `;
        }
    });

    loadStickyDefaultsColumns(options);

    delete options.zScreen;
    kGrid.kendoGrid(options);

    if (kGrid.find(".k-grid-toolbar").children().length == 0) {
        kGrid.find(".k-grid-toolbar").remove();
    }

    kendo.bind(`#${id}_SearchContainer .bind-label`, LocalizedLanguage);
    kendo.bind(`#${id}_SearchContainer_Actions .bind-label`, LocalizedLanguage);

    if (options.odataDataSource) {
        kGrid.data("kendoGrid").zRefresh = function () {
            var refreshButton = kGrid.find(".k-i-reload");
            if (refreshButton) {
                $(refreshButton).click();
                return true;
            } else {
                return false;
            }
        };
    }

    // Set a minimum width on the header table and the content table of the grid so that resizing the
    // window or opening sp10 on a smaller screen does not hide autofit columns (columns with no specified width).
    gridUtil.setGridMinimumWidth(kGrid, kGrid.data("kendoGrid").options.columns);

    kGrid.data("kendoGrid").mask = function (message) {
        kGrid.data("kendoGrid").content.append(maskUtil.newLoadingMask({
            instructions: ll((message || "LoadingGridData"), true)
        }));

        $.wait(5000).then(function () {
            var kendoGrid = kGrid.data("kendoGrid");
            if (!kendoGrid) {
                return;
            }

            var content = kendoGrid.content;
            if (!content) {
                return;
            }

            var stillLoading = content.find(".z-still-loading");
            if (stillLoading) {
                stillLoading.show();
            }

            var gridInstructions = content.find(".grid-instructions");
            if (gridInstructions) {
                gridInstructions.hide();
            }
        });
    };

    kGrid.data("kendoGrid").unmask = function () {
        var kendoGrid = kGrid.data("kendoGrid");
        if (!kendoGrid) {
            return;
        }

        var content = kendoGrid.content;
        if (!content) {
            return;
        }

        var gridInstructions = content.find(".grid-instructions-container");
        if (!gridInstructions) {
            return;
        }

        gridInstructions.remove();
    };

    kGrid.data("kendoGrid").zRefresh = function () {
        if ($(`#${id}_filterDataButton`).length !== 0) {
            $(`#${id}_filterDataButton`).click();
        } else {
            kGrid.data("kendoGrid").wrapper.find(".k-icon.k-i-reload").click();
        }
    };

    kGrid && kGrid.on("click", ".grid-icon", function (e) {
        var index = $.inArray(e.currentTarget, $(".grid-icon") as any),
            row = kGrid.find(`tbody tr:nth-child(${(index + 1)})`);
        kGrid.data("kendoGrid").select(row);
    });

    var getGridDataItemValue = function (e) {
        var closestGrid = $(e.currentTarget).closest(".k-grid"),
            kendoGrid = $(closestGrid).data("kendoGrid"),
            header = kendoGrid.thead,
            row = $(e.currentTarget).closest("tr"),
            cell = $(e.currentTarget).closest("td"),
            columnIndex = $("td", row).index(cell),
            columnField = header.find("th").eq(columnIndex).attr("data-field"),
            dataItem = kendoGrid.dataItem(row),
            value = _.get(dataItem, columnField);

        return value;
    };

    kGrid.tie("click", ".grid-signature-link", function (e) {
        var signatureId = getGridDataItemValue(e);
        if (signatureId) {
            var signaturePopup = new SignaturePopup();
            signaturePopup.popUp({ Id: signatureId });
        }

    });

    kGrid.tie("click", ".grid-url-link", function (e) {
        var value = getGridDataItemValue(e);
        if (value && typeof value === "string") {
            // label is before the pipe, url after
            var indexOfPipe = value.indexOf("|"),
                url = value.substring(indexOfPipe + 1);

            window.open(url, "_blank");
        }
    });

    // add print button
    if (options.allowExcelExport) {
        var printButton = $(`<a href='#' class='k-grid-excelExport k-link' title='${ll("ExportToExcel")}'><span class='grid-print k-i-excel k-icon'></span></a>`);

        printButton.insertAfter($(`#${options.id}`).find(".k-pager-refresh"));
        printButton.tie("click", function () {
            var kendoGrid = kGrid.data("kendoGrid");

            kGrid.mask();

            zKendo.setExprAlwaysSafe();
            kendoGrid.saveAsExcel();
        });
    }

    return kGrid.data("kendoGrid");
}

var getGridIdFromOptions = function (options) {
    var gridId = options.id;

    if (!gridId && options.gridObject) {
        gridId = $(options.gridObject).attr("id");
    }

    if (options.zScreen && options.zScreen.id) {
        gridId = `${options.zScreen.id}_${gridId}`;
    }

    options.id = gridId;

    return gridId;
};

var initializeOptions = function (options) {
    if (options.liveFilter == "false") {
        options.liveFilter = false;
    }

    options.searchOptions = options.searchOptions || [];
    options.hideSearchOptions = options.hideSearchOptions;
    options.autoBind = options.autoBind === undefined
        ? true
        : options.autoBind;
    options.dataSource = options.dataSource || null;
    options.entityTypes = options.entityTypes || [];
    options.odataDataSource = options.odataDataSource === undefined
        ? true
        : options.odataDataSource;

    options.noRecords = {
        template: "<div class='grid-instructions-container k-loading-mask'><div class='grid-instructions'  > #= z.ll(\"GridNoDataFound\", true) # </div></div>"
    };

    var entityTypeIndex = options.entityTypes[0] == null
        ? -1
        : options.entityTypes[0].indexOf("/");
    var mainEntityType = "";
    if (entityTypeIndex != -1) {
        mainEntityType = options.entityTypes[0].substring(0, entityTypeIndex);
    } else if (options.entityTypes[0] && options.entityTypes[0].length > 0) {
        mainEntityType = options.entityTypes[0];
    }

    options.mainEntityType = options.mainEntityType || mainEntityType;
    options.columns = options.columns || [];

    if (options.editButton || options.deleteButton) {
        var editDeleteColumn = {
            command: [],
            width: 0
        };

        if (options.editButton) {
            editDeleteColumn.command.push({
                className: "k-grid-edit",
                name: "edit",
                text: "&nbsp;"
            });

            options.editable = false;
        }

        if (options.deleteButton) {
            editDeleteColumn.command.push({
                className: "k-grid-delete",
                name: "destroy",
                text: "&nbsp;"
            });
        }

        editDeleteColumn.width = editDeleteColumn.command.length * 32;

        options.columns.push(editDeleteColumn);
    }

    options.columnMenu = options.columnMenu == undefined
        ? {
            messages: {
                columns: "Choose columns",
                filter: "Apply filter",
                sortAscending: "Sort (asc)",
                sortDescending: "Sort (desc)"
            }
        }
        : options.columnMenu;

    options.columnMenuInit = function (e) {
        var menu = e.container.find(".k-menu").data("kendoMenu"),
            theMainEntityType = ($(this.element).data("kendoGrid").options as any).mainEntityType,
            columns: any[] = this.options.columns,
            arrayOfMenuItems = $(menu.element).find(".k-columns-item .k-menu-group").children(),
            chooseColumnsMenuItem = $(menu.element).find(".k-columns-item");

        $(menu.element).find(".k-columns-item .k-menu-group").addClass("choose-column-container");

        if (areGridsEditable()) {
            var dictionary = {};
            $.each(arrayOfMenuItems, function (index, element) {
                var dataField = $(element).find("input").attr("data-field"),
                    col = columns[index],
                    isCode = false;

                if (col.field == dataField) {
                    isCode = col.isCode;
                }

                $(element).removeClass("k-first");
                $(element).removeClass("k-last");
                var entityType;

                // Parse out the entity type
                // Example Call.Customer.CustomerNumber, we want to show Customer as the entity

                if (dataField.indexOf(".") > 0) {
                    var entityHops = isCode ? 3 : 2;
                    entityType = dataField.split(".");
                    entityType = entityType[entityType.length - entityHops] || theMainEntityType;
                } else {
                    entityType = theMainEntityType;
                }

                if (dictionary[entityType]) {
                    dictionary[entityType].push(element);
                } else {
                    dictionary[entityType] = [];
                    dictionary[entityType].push(element);
                }
            });

            // Remove all the elements from the menu so we can readd them in order by their entity
            $(menu.element).find(".k-columns-item .k-menu-group").empty();

            // Recreate the menu with the column headings
            for (var key in dictionary) {
                if (dictionary.hasOwnProperty(key)) {
                    var heading = key;
                    if (LocalizedLanguage[`Entity.${key}`]) {
                        heading = `Entity.${key}`;
                    }
                    $(menu.element).find(".k-columns-item .k-menu-group").append(`<li class="" role="menuitem"><span class="z-grid-menu-dropdown-heading ">${ll(heading)}</span></li>`);
                    // alphabetize each array in the dictionary
                    dictionary[key].sort(function (a, b) {
                        a = $(a).find("span").text().toLowerCase();
                        b = $(b).find("span").text().toLowerCase();
                        if (a < b) {
                            return -1;
                        }
                        if (a > b) {
                            return 1;
                        }
                        return 0;
                    });

                    for (var i = 0; i < dictionary[key].length; i++) {
                        $(menu.element).find(".k-columns-item .k-menu-group").append(dictionary[key][i]);
                    }
                }
            }
        } else {
            chooseColumnsMenuItem.disable();
            chooseColumnsMenuItem.find(".k-menu-expand-arrow").remove();

            controls.toolTip({
                content: ll("DisabledChooseColumnsTooltip"),
                alignX: "left",
                alignY: "center",
                alignTo: "target",
                offsetX: 5,
                selector: chooseColumnsMenuItem
            });
        }

        var field = e.field,
            gridId = this.options.id,
            column = _.find(columns, function (element) {
                if (element.field == field) {
                    return true;
                }
                return false;
            }),
            filterMenu = new GridFilterMenu({
                menu: menu,
                column: column,
                field: field,
                gridId: gridId,
                mainEntityType: theMainEntityType,
                menuContainer: e.container.find("ul")
            });
        filterMenu.create();

        fixGridFilterMenuForChrome(menu);
    };

    options.editable = options.editable === undefined
        ? false
        : options.editable;

    options.filterable = options.filterable != undefined ? options.filterable : {
        // mode: "row",
        extra: true,
        messages: {
            value: "Choose value",
            operator: "Choose operator",
            cancel: "Cancel",
            selectValue: "Select Value",
            or: "or",
            and: "and",
            isTrue: "True",
            isFalse: "False",
            info: "Filter Results",
            filter: "Apply filter",
            clear: "Clear filter"
        },
        operators: {
            string: {
                startswith: "Starts with",
                contains: "Contains",
                doesnotcontain: "Doesn't contain",
                endswith: "Ends with",
                eq: "Equal to",
                neq: "Not equal to"
            },
            number: {
                eq: "Equal to",
                neq: "Not equal to",
                gte: "Greater than or equal to",
                gt: "Greater than",
                lte: "Less than or equal to",
                lt: "Less than"
            },
            date: {
                eq: "Equal to",
                neq: "Not equal to",
                gte: "Greater than or equal to",
                gt: "Greater than",
                lte: "Less than or equal to",
                lt: "Less than"
            }
        }
    };

    options.groupable = options.groupable === undefined
        ? false
        : options.groupable;

    options.navigatable = options.navigatable === undefined
        ? true
        : options.navigatable;

    options.pageable = (options.pageable != undefined) ? options.pageable : {
        refresh: true,
        pageSizes: [5, 10, 15, 25, 50, 100],
        buttonCount: 5,
        messages: {
            display: ll("PageableDisplay"),
            empty: ll("PageableEmpty"),
            of: ll("PageableOf"),
            itemsPerPage: ll("PageableItemsPerPage"),
            first: ll("PageableFirst"),
            last: ll("PageableLast"),
            next: ll("PageableNext"),
            previous: ll("PageablePrevious"),
            refresh: ll("PageableRefresh")
        }
    };

    options.resizable = options.resizable === undefined
        ? true
        : options.resizable;

    options.reorderable = options.reorderable === undefined
        ? true
        : options.reorderable;

    options.rowTemplate = options.rowTemplate || null;
    options.selectable = options.selectable === undefined
        ? "row"
        : options.selectable;

    options.scrollable = options.scrollable === undefined
        ? true
        : options.scrollable;

    options.toolbar = options.toolbar;
    options.excel = {
        allPages: true,
        sortable: true,
        filterable: true,
        reorderable: true,
        resizable: true
    };
    options.sortable = options.sortable === undefined
        ? { allowUnsort: true, mode: "single" }
        : options.sortable;
    options.toolbar = options.toolbar || [];
    options.parent = options.parent || "";
    options.url = options.url || null;
    options.preFilter = options.preFilter || null;
    options.schema = options.schema || null;
    options.show = options.show || null;
    options.hide = options.hide || null;
    options.excluded = options.excluded || null;
    options.useNumericInputs = options.useNumericInputs === undefined
        ? false
        : options.useNumericInputs;

    options.columnOrder = options.columnOrder || [];
    options.columns = options.columns || [];
    options.columnsToRemove = options.columnsToRemove || [];
    options.liveFilter = options.liveFilter === undefined
        ? true
        : options.liveFilter;

    options.expand = options.expand || "";
    options.select = options.select || "";
    options.dtoDeletes = options.dtoDeletes || [];
    options.columnRenames = options.columnRenames || {};
    options.searchType = options.searchType || searchTypes.generate(options.mainEntityType);
    options.searchType.entityTypes = options.searchType.entityTypes || [];
    options.entityTypes = options.entityTypes.concat(options.searchType.entityTypes).getUnique();
    options.columnRenames = $.extend({}, options.searchType.columnRenames, options.columnRenames);
    options.columnsToHide = options.columnsToHide || [];
    options.allowExcelExport = options.allowExcelExport === undefined
        ? true
        : options.allowExcelExport;

    if (options.useSearchType) {
        options.columnOrder = options.overrideColumnOrder || options.columnOrder.concat(options.searchType.columnOrder || []);
        options.columns = options.columns.concat(options.searchType.columns || []);

        if ($.isFunction(options.select)) {
            var originalSelect = options.select;
            options.select = function () {
                return `${originalSelect()}, ${options.searchType.select}`;
            };
        } else {
            options.select = options.select
                ? `${options.select}, ${options.searchType.select}`
                : options.searchType.select;
        }

        options.expand = options.expand
            ? `${options.expand}, ${options.searchType.expand}`
            : options.searchType.expand;

        if (typeof options.useSearchType.useSearchOptions === "undefined" || options.useSearchType.useSearchOptions) {
            options.searchOptions = options.searchOptions.concat(options.searchType.searchOptions || []);
        }
        if (options.filter && options.searchType.filter) {
            options.filter = `(${options.filter}) AND (${options.searchType.filter})`;
        } else {
            options.filter = options.filter || options.searchType.filter;
        }

    }
};

var initializeDataSource = function (options) {
    if (!options.dataSource && (options.url || options.entityTypes.length > 0)) {
        if (!options.url && options.entityTypes.length > 0) {
            options.url = "" + options.mainEntityType;
        }

        $.each(options.entityTypes, function (index, type) {
            if (options.expand.length > 0) {
                options.expand += ", ";
            }
            var expand = type;
            if (expand.indexOf("/") != -1) {
                expand = expand.substring(expand.indexOf("/") + 1);
            }

            options.expand += expand;
        });

        const headers = {};
        if (options.companyGuid) {
            headers["Company-GUID"] = options.companyGuid;
        }

        var urlPrefix = options.urlPrefix || "",
            gridSort = options.sort,
            gridFilter = options.filter;
        var ds = dataSource({
            pageSize: options.defaultPageSize || 10,
            sort: gridSort || [],
            transport: {
                read: {
                    url: `${urlPrefix}${options.url}`,
                    beforeSend: options.beforeSend,
                    headers
                },
                update: {
                    url: `${urlPrefix}${options.url}`,
                    beforeSend: options.beforeSend
                },
                parameterMap: function (data, type) {
                    if (type == "update") {
                        var dto = clone(data.models[0]);

                        $.each(options.dtoDeletes, function (index, deleteField) {
                            delete dto[deleteField];
                        });

                        return JSON.stringify(dto);
                    }

                    var sort = gridSort,
                        filter = gridFilter,
                        select = options.select,
                        expand = options.expand;
                    if (isFunction(sort)) {
                        sort = sort();
                    }

                    if (isFunction(filter)) {
                        filter = filter();
                    }

                    if (isFunction(select)) {
                        select = select();
                    }

                    if (isFunction(expand)) {
                        expand = expand();
                    }

                    var kendoGrid = $(`#${options.id}`).data("kendoGrid"),
                        selectExpression = select;

                    $.each(kendoGrid.columns as any[], function (index, column) {
                        // TODO: Potentially use another field instead of Field

                        if (column.field) {
                            var field = column.field;

                            if (column.isCode) {
                                field = column.codeFieldIdName;
                            }

                            var refactoredColumn1 = field.replaceAll("/", "."),
                                refactoredColumn2 = field.replaceAll(".", "/");

                            if (!column.hidden
                                && selectExpression.indexOf(field) == -1
                                && selectExpression.indexOf(refactoredColumn1) == -1
                                && selectExpression.indexOf(refactoredColumn2) == -1) {

                                if (selectExpression.length > 0) {
                                    selectExpression += ", ";
                                }

                                // if (field.indexOf(".") != -1) {
                                //    field = field.substring(field.indexOf(".") + 1);
                                // }

                                selectExpression += field;
                            }
                        }
                    });

                    // Last Ditch effort to get the expand for all the selects
                    var selects = selectExpression.split(","),
                        expands = [];

                    $.each(expand.split(","), function () {
                        expands.push($.trim(this));
                    });

                    $.each(selects, function (index, value) {
                        value = value.replaceAll(".", "/");
                        if (value.indexOf("/") != -1) {

                            var newExpand = value.substr(0, value.lastIndexOf("/"));
                            expands.push($.trim(newExpand));
                        }
                    });

                    var replaceUDFComboFields = function (item) {
                        if (item.field) {
                            var column = _.find(options.columns as any[], function (c) {
                                return c.field == item.field;
                            });
                            if (column && column.UserDefinedListId) {
                                item.field = item.field.replace("UDF_", "UDFLV_") + ".CodeNumber";
                            }
                        } else if (item.filters) {
                            $.each(item.filters, function (index, itemFilters) {
                                replaceUDFComboFields(itemFilters);
                            });
                        }
                    };

                    if (data.sort) {
                        $.each(data.sort, function (index, item) {
                            replaceUDFComboFields(item);
                        });
                    }

                    return buildODataKendoParams({
                        data: data,
                        sortExpression: sort,
                        filterExpression: filter,
                        selectExpression: selectExpression,
                        expandExpression: expands.getUnique().join(", ")
                    });
                }
            }
        });

        options.dataSource = ds;
    }
};

/**
 * z.layout.buildGridColumns adds templates to the columns it creates, but when the columns are specified elsewhere
 * we also want to add templates for dates, times, datetimes, and currency.
 */
var applyTemplatesToColumns = function (options) {
    var entityType = options.mainEntityType,
        columns: any[] = options.columns || [];

    if (!entityType) {
        return columns;
    }

    var schema = schemas[entityType];
    if (!schema) {
        return columns;
    }

    var columnsWithoutTemplates = $.grep(columns, function (column) {
        return column.field && !column.template;
    });
    $.each(columnsWithoutTemplates as any[], function (index, column) {
        var property = getSchemaProperty({
            entity: entityType,
            property: column.field
        });
        if (property) {
            try {
                var propertyInfo = schema.getPropertyInfo({
                    entityName: entityType,
                    path: column.field
                });

                column.codeName = column.codeName || propertyInfo.entityName;
                column.codeProperty = column.codeProperty || propertyInfo.propertyName;
            } catch (e) {
            }
            column.template = column.template ||
                layout.getTemplateForType({
                    type: property.Type,
                    field: column.field,
                    codeName: column.codeName,
                    codeProperty: column.codeProperty,
                    codeFieldIdName: column.codeFieldIdName,
                    UserDefinedListId: column.UserDefinedListId
                });

        }
    });

    return columns;
};

var loadStickyDefaultsPageSizeAndSort = function (options) {
    if (!options.stickyDefaultName) {
        return;
    }

    var field = options.stickyDefaultName;
    if (options.widgetId && !field) {
        field = options.widgetId;
    }
    var stickyDefaults = getGridStickyDefaults({
        EntityName: options.mainEntityType,
        Field: field
    }).Value || {};
    if (stickyDefaults.PageSize) {
        options.defaultPageSize = stickyDefaults.PageSize;
    }
    if (stickyDefaults.Sort) {
        options.sort = stickyDefaults.Sort;
    }
};

var loadStickyDefaultsColumns = function (options) {
    if (!options.stickyDefaultName) {
        return;
    }

    var field = options.stickyDefaultName;
    if (options.widgetId && !field) {
        field = options.widgetId;
    }
    var stickyDefaults = getGridStickyDefaults({ EntityName: options.mainEntityType, Field: field }).Value || {},
        defaultColumns: any[] = stickyDefaults.Columns || [];

    _.forEach(options.columns, function (column) {
        var defaultColumn = _.find(defaultColumns, function (c) { return c.field == column.field; });
        if (!defaultColumn) {
            return;
        }
        if (defaultColumn.hidden !== undefined) {
            column.hidden = defaultColumn.hidden;
        }
        if (defaultColumn.width !== undefined) {
            column.width = defaultColumn.width;
        }
    });

    var defaultColumnOrder = _(defaultColumns).map(function (c) { return c.field; }).filter(function (c) { return c; }).value(),
        orderedColumns = [];

    // columnOrder columns first, in the order they appear in columnOrder
    _.forEach(defaultColumnOrder, function (columnField) {
        var foundColumn = _.find(options.columns as any[], function (column) {
            return column.field == columnField;
        });
        if (foundColumn) {
            orderedColumns.push(foundColumn);
        }
    });

    // non-columnOrder columns after, in the order they appear in columns
    _.forEach(options.columns, function (column) {
        var foundColumn = _.find(defaultColumnOrder, function (columnField) {
            return column.field == columnField;
        });
        if (!foundColumn) {
            orderedColumns.push(column);
        }
    });

    if (!areGridsEditable()) {
        orderedColumns = _.filter(orderedColumns, (column: any) => !column.hidden);
    }

    options.columns = orderedColumns;
};

var saveStickyDefaults = function (options, kendoGrid) {
    if (!options.stickyDefaultName) {
        return;
    }

    var gridOptions = kendoGrid.getOptions(),
        columns: any[] = gridOptions.columns,
        pageSize = gridOptions.dataSource.pageSize,
        sort = gridOptions.dataSource.sort;

    columns = _.map(columns, function (column) {
        return {
            field: column.field,
            hidden: column.hidden,
            width: column.width
        };
    });

    var field = gridOptions.stickyDefaultName;
    setGridStickyDefaults({
        EntityName: gridOptions.mainEntityType,
        Field: field,
        Value: {
            Columns: columns,
            PageSize: pageSize,
            Sort: sort
        }
    });
};

var areGridsEditable = function () {
    return (localStorage.getItem("EditGrids") || "").toLowerCase() === "true" ||
        settings.brandName === "admin";
};
